<template>
  <div
    class="account-invitations"
  >
    <!-- {{getProjectInvites}} -->
    <div
      v-for="invite, index in getProjectInvites"
      :key="`invite#${invite.id}`"
      class="account-invitations-element"
    >
      <TText
        value="Invited_by_{issuer}"
        :value_props="{issuer: invite.issuer}"
        font_weight="400"
      />
      <ProjectCardOnSite
        :header="invite.project.name"
        :image="invite.project.image"
        :role="invite.prole"
        :status="invite.created.split(' UTC')[0]"
      >
      <!-- :loading="project.id === project_id_loading ? true : false" -->
        <template #body>
          <!-- BOTTOM HALF -->
          <div
            v-if="invite.work_packages.length"
            class="account-invitations-info-wps"
          >
            <!-- SHOWS WP TYPES -->
            <WorkPackage
              v-for="(work_package, index) in getWorkpackageArray(invite)"
              style="flex-shrink: 0;"
              :key="index"
              :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
              :token="work_package.token"
              :icon="work_package.icon"
              :zoom="1"
            >
              <!-- SHOWS AMOUNT OF WP -->
              <template #workpackage>
                <StandardBadge
                  color="white"
                  :text="work_package.count"
                  content_color="black"
                  :zoom="1"
                />
              </template>
            </WorkPackage>

            <!-- MORE DISPLAY FOR MISSING WPS -->
            <div
              v-if="getNeedsMorePlaceholder(invite.work_packages.length)"
              class="account-invitations-more-wp"
              :style="`border-color: ${getTranspHexColor(getColor('primary'), 0.2)};`"
            >
              <!-- SHOWS MISSING WP TYPES -->
              <TText
                :text="`+${invite.work_packages.length - wp_space_count + 1}`"
                :color="getTranspHexColor(getColor('primary'), 0.2)"
                font_weight="500"
              />
              <!-- SHOWS AMOUNT OF MISSING WPS -->
              <StandardBadge
                color="white"
                :text="getMissingWorkPackageCount(invite.work_packages)"
                content_color="black"
                :zoom="1"
              />
            </div>
          </div>
        </template>
      </ProjectCardOnSite>
      <div
        class="account-invitations-buttons"
      >
        <ButtonOutlined
          icon="check-large"
          value="Accept"
          color="green"
          width="120"
          @buttonClicked="acceptProjectInvite(invite)"
        />
        <ButtonOutlined
          icon="close"
          value="Decline"
          color="red"
          width="120"
          @buttonClicked="declineProjectInvite(invite)"
        />
      </div>
      <div
        v-if="getProjectInvites.length -1 !== index"
        class="account-invitations-line"
        :style="`
          border-color: ${getColor('primary')};
        `"
      />
    </div>
    <TText v-if="getProjectInvites.length === 0" value="You have no Invites" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { TColor } from '@/mixins/TColor.mixin.js';

import ProjectCardOnSite from '@/components/ProjectOverView/ProjectCardOnSite.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

export default {
  props: [],

  components: {
    ProjectCardOnSite,
    WorkPackage,
    StandardBadge,
    ButtonOutlined,
  },

  mixins: [
    TColor,
  ],

  data: () => ({
  }),

  computed: {
    ...mapGetters('User',[
      'getProjectInvites'
    ]),

    wp_space_count() {
      // screenwidth - padding TFinder - sidebarLeft - paddingLeft - image width - inner padding
      let avaiable_space = screen.width - 2 * 2 - (this.$vuetify.breakpoint.smAndUp ? 240 : 50) - 20 - 80 - 2 * 8;
      let ret = Math.floor(avaiable_space / (54 + 2 * 2)); // wp width (54) + 2 * margin (2)
      return ret;
    },
  },

  methods: {
    ...mapActions('ProjectInvitation', [
      'acceptProjectInvite',
      'declineProjectInvite'
    ]),

    getWorkpackageArray(project) {
      let arr = project.work_packages;
      if(this.getNeedsMorePlaceholder(arr.length))
        { return arr.slice(0, this.wp_space_count - 1); }
      else
        { return arr; }
    },

    getNeedsMorePlaceholder(wp_count) {
      return wp_count > this.wp_space_count - 1 && wp_count != this.wp_space_count;
    },

    getMissingWorkPackageCount(work_packages) {
      let count = 0;
      for(let i = this.wp_space_count - 1; i < work_packages.length; i++) {
        count += work_packages[i].count;
      }
      return count;
    },
  }
}
</script>

<style>
.account-invitations {
  padding: 20px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.account-invitations-element {
  display: flex;
  flex-direction: column;
  grid-gap: 2px;
}
.account-invitations-info-wps {
  flex-grow: 1;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
}
.account-invitations-more-wp {
  width: var(--workpackage_width);
  height: var(--workpackage_height);
  border: 1px solid;
  margin: 2px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.account-invitations-buttons {
  display: flex;
  padding-top: 4px;
  grid-gap: 8px;
}
.account-invitations-line {
  width: 100%;
  border-bottom: 1px solid red;
  margin: 8px 0;
  opacity: 0.1;
}
</style>
